export default {"src":"/_next/static/media/nora-round.038f45a4.svg","height":907,"width":907,"blurWidth":0,"blurHeight":0};